import React from 'react';
import { Icon, Image, Menu } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import findResult, { findSelected } from '@/utils/resultsHelper';
import CohortChartDropdown from '../components/CohortChartDropdown';
import CohortAxisContainer from './CohortAxisContainer';
import CohortBoxPlotVariables from './CohortBoxPlotVariables';
import { toggleCohortVisualisationSelected } from '../actions';
import { cohortChartIcon } from '../components/CohortChartDropdownItems';
import CohortVisibilityChanger from '../../containers/CohortVisibilityChanger';
import CohortHistogramVariables from './CohortHistogramVariables';
import { toggleExpandedCharts } from '../../actions';

const components = {
  bar: CohortAxisContainer,
  box: CohortBoxPlotVariables,
  stackedBar: CohortAxisContainer,
  histogram: CohortHistogramVariables,
};

const CohortVisualisationMenu = ({
  category,
  code,
  chartType,
  selectChart,
  includeVisibility,
  expandedCharts,
  toggleExpanded,
  compact,
}) => {
  const intl = useIntl();
  const Component = components[chartType];

  const expandedChartsMsg = (expanded) => {
    const msg = 'cohort.visualisation.full.screen';
    return expanded ? `${msg}.on` : `${msg}.off`;
  };

  const expandedChartsIcon = (expanded) => (expanded ? 'compress' : 'expand');

  return (
    <Menu className="aridhia-cohort-visualisation-menu" size="massive">
      {!compact && (
        <Menu.Item
          name={expandedChartsIcon(expandedCharts)}
          onClick={() => toggleExpanded(category, code)}
          title={intl.formatMessage({ id: expandedChartsMsg(expandedCharts) })}
          className="aridhia-cohort-visualisation-expand-toggle"
        >
          <Icon name={expandedChartsIcon(expandedCharts)} size="large" />
        </Menu.Item>
      )}
      <Menu.Item className="p-8" active>
        <Image src={cohortChartIcon[chartType.toLowerCase()]} size="mini" />
      </Menu.Item>
      <CohortChartDropdown chart={chartType} onChange={(value) => selectChart(category, code, value)} />
      <Component code={code} category={category} chartType={chartType} />
      {includeVisibility && (
        <Menu.Item position="right"><CohortVisibilityChanger code={code} category={category} /></Menu.Item>
      )}
    </Menu>
  );
};

const mapStateToProps = ({
  cohorts: { cohorts },
}, { category, code }) => {
  const item = findResult(cohorts, category, code);
  const chart = findSelected(item.visualisations)[0];

  return (
    {
      chartType: chart.code,
      expandedCharts: item.expandedCharts,
    }
  );
};

export const mapDispatchToProps = {
  selectChart: toggleCohortVisualisationSelected,
  toggleExpanded: toggleExpandedCharts,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortVisualisationMenu);
